// Friendly denial page for users signed in but in no recognized group.
// Triggered when AuthProvider resolves status === 'unauthorized'.

export function Unauthorized({ userName }) {
  return (
    <div className="app">
      <header className="header">
        <img
          src="/PSC Group Logo Horizontal Color.png"
          alt="PSC Group"
          className="header-logo"
        />
        <div style={{ flex: 1 }} />
        <div className="header-text">
          <h1>Billing Integration</h1>
          <span className="subtitle">DAYFORCE &rarr; NETSUITE</span>
        </div>
      </header>
      <main
        className="main"
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '60vh',
        }}
      >
        <div
          className="alert alert-warning"
          style={{
            maxWidth: 560,
            padding: '24px 32px',
            textAlign: 'center',
          }}
        >
          <h2 style={{ marginTop: 0 }}>Access required</h2>
          <p>
            You're signed in
            {userName ? (
              <>
                {' '}as <strong>{userName}</strong>
              </>
            ) : null}, but you are not a member of any PSC Billing role
            group, so you can't access the application.
          </p>
          <p>
            Ask the PSC IT or Billing team to add you to one of the
            following Entra security groups depending on the access you need:
          </p>
          <ul style={{ textAlign: 'left', display: 'inline-block', margin: '8px 0 16px' }}>
            <li><strong>System Admin Access</strong> — full access incl. Audit Log</li>
            <li><strong>Billing Access</strong> — normal billing workflow (no Audit Log)</li>
            <li><strong>View Only</strong> — read-only access</li>
          </ul>
          <p style={{ marginBottom: 0 }}>
            <a href="/.auth/logout">Sign out</a> and try again with a
            different account.
          </p>
        </div>
      </main>
    </div>
  );
}
